<template>
  <label :class="`bundle bundle-${color}`">
    {{ title }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      amd_human: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    computed: {
      title: function () {
        if (this.amd_human === false) {
          return this.$t(`autocaller_v2.campaign.answering_machine`);
        } else {
          return this.$t(`autocaller_v2.stats.state.${this.value}`);
        }
      },

      color: function () {
        if (this.amd_human === false) {
          return 'pink';
        }
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'ANSWERED': {
            return 'green';
          }
          case 'NO_ANSWER': {
            return 'fresh';
          }
          case 'ERROR': {
            return 'error';
          }
          case 'FAILED': {
            return 'gray';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
